export default function NameOrEmail({ searchObject, onChange, t }) {
  return (
    <div>
      <legend className="fontsize-legend">{t("Name Or Email")}</legend>
      <input
        className="form-control fontsize-legend"
        placeholder={t("Name or Email")}
        name="nameOrEmail"
        onChange={onChange}
        value={searchObject.nameOrEmail || ""}
      />
    </div>
  );
}
